import { render } from "./FridgeDetailsConfirmSettingsDialogItem.vue?vue&type=template&id=5f30189b&scoped=true&ts=true"
import script from "./FridgeDetailsConfirmSettingsDialogItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsConfirmSettingsDialogItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsConfirmSettingsDialogItem.vue?vue&type=style&index=0&id=5f30189b&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f30189b"]])

export default __exports__